<div class="flex h-full flex-col">
  <app-page-header [title]="'manageSubscription.title' | transloco" />

  <div class="flex flex-1">
    @if (loading) {
      <div class="flex w-full items-center justify-center">
        <app-greentripper-loader />
      </div>
    } @else if (showUpdateCompanyInfo) {
      <div class="flex w-full items-center justify-center">
        <app-update-company-info (companyUpdated)="loadPackList()" />
      </div>
    } @else {
      <section class="w-full rounded-md border border-gray-200 bg-white p-4">
        <app-pack-selector
          [packList]="packList"
          [(selectedPack)]="selectedPack"
        />
      </section>
    }
  </div>
</div>
